import type { PlayEvent, PlayEventParticipant } from '@court-sync/shared';
import { getPlayEventParticipantDisplayName } from '@court-sync/shared';
import { PlayEventDrawPlayerSlot } from '@/components/play/PlayEventDrawPlayerSlot';
import type { PlayerRatingSettings } from '@court-sync/shared';

interface UnevenPlayerSlotProps {
  event: PlayEvent;
  organizationId: string;
  eventId: string;
  ratingSettings: PlayerRatingSettings | null;
  editable: boolean;
  draggingParticipantId?: string | null;
  onUpdated?: () => void;
}

interface PlayEventDrawUnevenPlayersPanelProps extends UnevenPlayerSlotProps {
  title: string;
  description?: string;
  participants: PlayEventParticipant[];
  emptyMessage?: string;
}

export function PlayEventDrawUnevenPlayersPanel({
  title,
  description,
  participants,
  emptyMessage,
  ...slotProps
}: PlayEventDrawUnevenPlayersPanelProps) {
  if (participants.length === 0 && !emptyMessage) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div>
        <p className="text-sm font-medium text-foreground">{title}</p>
        {description ? <p className="text-xs text-muted-foreground">{description}</p> : null}
      </div>
      {participants.length > 0 ? (
        <div className="space-y-1 rounded-xl border border-dashed border-border bg-muted/20 p-3">
          {participants.map((participant) => (
            <PlayEventDrawPlayerSlot
              key={participant.id}
              participant={participant}
              {...slotProps}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">{emptyMessage}</p>
      )}
    </div>
  );
}

export function formatUnevenPlayerNames(participants: PlayEventParticipant[]): string {
  return participants.map((participant) => getPlayEventParticipantDisplayName(participant)).join(', ');
}
